import request from '@/utils/request'

export function getConfig(data) {
  return request({
    url: '/ai/config',
    method: 'get',
    params: data
  })
}

export function getChatStream(data) {
  return request({
    url: '/ai/chatStream',
    method: 'post',
    data: data
  })
}

export function getChatStreamStop(data) {
  return request({
    url: '/ai/chatStream/stop',
    method: 'post',
    data: data
  })
}

export function getDataList(data) {
  return request({
    url: '/ai/tti/list',
    method: 'GET',
    params: data
  })
}

export function getDetails(id) {
  return request({
    url: `ai/tti/${id}`,
    method: 'GET'
  })
}

export function getGenLog(data) {
  return request({
    url: '/ai/tti/genLog',
    method: 'post',
    data: data
  })
}

/**
 * 获取图生图图片列表
 * @param data
 * @returns {AxiosPromise}
 * */
export function getImageDataList(data) {
  return request({
    url: '/ai/iti/list',
    method: 'GET',
    params: data
  })
}

export function getImageGenLog(data) {
  return request({
    url: '/ai/iti/genLog',
    method: 'post',
    data: data
  })
}

export function getImageDetails(id) {
  return request({
    url: `ai/iti/${id}`,
    method: 'GET'
  })
}

export function toggleUserPrompt(promptId) {
  return request({
    url: `/ai/tti/toggleUserPrompt/${promptId}`,
    method: 'post'
  })
}

export function getOssAssumeRole() {
  return request({
    url: '/getOssImgToken',
    method: 'get'
  })
}

export function getUserTask(params) {
  return request({
    url: '/ai/d/task',
    method: 'get',
    params
  })
}

export function delLogTask(id) {
  return request({
    url: `/ai/d/task/del/${id}`,
    method: 'delete'
  })
}

export function getFavoriteList(params) {
  return request({
    url: '/ai/d/task/favoriteList',
    method: 'get',
    params
  })
}

export function updateFavorite(id) {
  return request({
    url: `/ai/d/task/favorite/${id}`,
    method: 'PATCH'
  })
}
